import React from "react";
import LegacySector from "../Constants/Sector.legacy.json";

export function parseSector(sectors) {
    if (sectors) {
        let sectorList = Number.isInteger(sectors)? [sectors] : (sectors
            .split(",")
            .filter(a => a) // to ensure there is no rogue data
            .map(a => Number(a)));
        let result = removeLegacySector(sectorList);
        if (result.length) return result.join(",");
    }
    return null;
}

export function removeLegacySector(sectors) {
    return Array.isArray(sectors)? sectors.filter(formSector => !LegacySector.some(sector => 
        sector.value === formSector
    )) : [];
}

export function useSectorMigration(setFormData, keys) {
    React.useEffect(() => {
        setFormData(formData => {
            if (!formData) return formData;
            const finalResult = {...formData};
            let changed = false;
            keys.forEach(key => {
                const formSectors = removeLegacySector(formData[key]);
                if (formSectors?.length) {
                    finalResult[key] = formSectors
                    if (finalResult[key]?.length !== formSectors?.length) {
                        changed = true;
                    }
                } 
            });
            if (changed) return finalResult;
            else return formData;
        });
    }, [setFormData, keys])
}